// ##############################
// // // PricingCard component styles
// #############################

import {
  card,
  //customFont,
  blackColor,
  whiteColor,
  primaryColor,
  redColor,
  yellowColor,
  purpleColor,
  pinkColor,
} from 'assets/styles/jss/main';

const pricingCardStyle = {
  card: {
    ...card,
    textAlign: 'center',
    boxShadow:
      '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    height: 'calc(100% - 25px)',
    marginBottom: 0,
  },
  cardPlain: {
    background: 'transparent',
    boxShadow: 'none',
  },
  cardContent: {
    padding: '5px !important',
    position: 'relative',
    height: '100%',
  },
  cardTitle: {
    marginBottom: '0',
    marginTop: '10px',
    color: '#999999',
    fontSize: '14px',
  },
  cardPrice: {
    marginTop: '5px',
    marginBottom: '3px',
    color: '#3C4858',
    //...customFont
  },
  cardDescription: {
    color: blackColor,
    fontSize: '16px',
    padding: '0 20px',
    marginBottom: '100px',
  },
  primary: {
    color: primaryColor,
  },
  red: {
    color: redColor,
  },
  yellow: {
    color: yellowColor,
  },
  purple: {
    color: purpleColor,
  },
  pink: {
    color: pinkColor,
  },
  white: {
    color: whiteColor,
  },
  iconWrapper: {
    margin: '0px auto 0px',
    fontSize: '45px',
    width: '50px',
    lineHeight: '50px',
    height: '50px',
  },
  iconWrapperOnPlain: {
    border: '1px solid #FFFFFF',
  },
  icon: {
    width: '45px',
    height: '45px',
    top: '6px',
    position: 'relative',
  },
};

export default pricingCardStyle;
